import {
    ChangeDetectorRef,
    Component,
    DestroyRef,
    Inject,
    OnInit,
    PLATFORM_ID,
    Signal,
} from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { HotelData } from "@app/components/hotels/hotelInterface";
import { KEYWORDSLIST } from "@app/components/keywords/keywordList";
import { MapService } from "@app/services/map.service";

@Component({
    selector: "app-hoteldetails",
    templateUrl: "./hoteldetails.component.html",
    styleUrls: ["./hoteldetails.component.scss"],
    standalone: false,
    providers: [],
})
export class HotelDetailsComponent implements OnInit {
    protected map = null;
    tabs = ["Beschreibung", "Ausstattung", "Bewertung", "Karte"];
    selectedTab: string = this.tabs[0];
    features = [];
    allFeatures = [];
    title: string = "";
    hotel = null;
    data = null;
    offerObj;

    constructor(
        protected dialogRef: MatDialogRef<HotelDetailsComponent>,
        @Inject(MAT_DIALOG_DATA)
        protected res: {
            hotel: HotelData;
            func: () => void;
            reviews: Signal<[]>;
            title: string;
            rating: string;
            tab: number;
            mode: string;
        },
        @Inject(PLATFORM_ID) protected platformId: Object,
        protected mapService: MapService,
        protected cdr: ChangeDetectorRef,
        protected destroyRef: DestroyRef
    ) {
        this.hotel = this.res.hotel;
        this.data = {
            reviews: this.res.reviews,
            title: this.res.title,
            rating: this.res.rating,
        };
    }

    ngOnInit() {
        this.getFeatures();
        this.offerObj = this.hotel.catalogData;
        this.selectedTab = this.tabs[this.res.tab || 0];
    }

    navigate(index) {
        this.selectedTab = this.tabs[index];
    }
    closePanel() {
        this.dialogRef.close();
    }

    getFeatures() {
        KEYWORDSLIST.forEach((key) => {
            if (this.hotel.keywordList.includes(key.code)) {
                this.features.push(key);
            }
        });
        this.cdr.detectChanges();
    }

    onReg() {
        this.res.func();
    }
}
